import React from 'react';
import { Link } from 'react-router-dom';

const GAMES = [
  {
    id: 'battleship',
    name: 'Portfolio Warfare',
    icon: '💼',
    description: 'An exercise in team work and crisis management.',
    playPath: '/games/battleship',
    color: '#4488ff',
  },
  {
    id: 'briefcase',
    name: 'A Brief Case',
    icon: '💰',
    description: 'High-stakes team decision making.',
    playPath: '/games/briefcase',
    color: '#ffaa00',
  },
  {
    id: 'minigolf',
    name: 'Dead Cat Bounce',
    icon: '📉',
    description: 'Team skill challenge.',
    playPath: '/games/minigolf',
    color: '#44ff44',
  },
];

const GamesPage = () => {

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h2 style={{ color: '#00ff88', textAlign: 'center', marginBottom: '20px', letterSpacing: '2px' }}>
        MACRO GAMES
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {GAMES.map(game => (
          <div
            key={game.id}
            style={{
              background: '#1a1a2e',
              border: '2px solid #333',
              borderRadius: '12px',
              padding: '16px',
              transition: 'all 0.3s ease',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <span style={{ fontSize: '32px' }}>{game.icon}</span>
              <div>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: game.color }}>{game.name}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{game.description}</div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <Link
                to={game.playPath}
                style={{
                  flex: 1,
                  textAlign: 'center',
                  padding: '10px',
                  background: `color-mix(in srgb, ${game.color} 20%, #1a1a2e)`,
                  border: `1px solid ${game.color}`,
                  borderRadius: '8px',
                  color: game.color,
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '14px',
                }}
              >
                Play
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GamesPage;
